export default __webpack_public_path__ + "static/media/excavation4.e50822f6.jpg";